import { of } from "rxjs";
import { catchError, filter, map, mergeMap } from "rxjs/operators";
import { LOCATION_CHANGE } from "connected-react-router";

import { Effect } from "../../../redux/types/effect.type";
import { EffectActionsObservable } from "../../../redux/types/effect-actions-observable.type";
import { isActionType } from "../../../redux/action.functions";

import { CommentsActions } from "./comments.actions";
import * as actions from "./comments.actions";
import * as store from "./comments.store";

import * as commentsServices from "../services/comments.service";
import { FetchCommentsQuery } from "../types/comments-queries/comments-queries.interface";
import { orderComments } from "../services/comments.service";
import { StateObservable } from "redux-observable";
import { RootState } from "../../../redux/store";

const fetchAfterPost: Effect = (action$: EffectActionsObservable) =>
  action$.pipe(
    filter(isActionType(CommentsActions.PostSuccess)),
    map((action) => action.payload),
    map((params) => actions.fetch(params.resourceId, params.resourceType))
  );

const fetchComments: Effect = (action$: EffectActionsObservable) =>
  action$.pipe(
    filter(isActionType(CommentsActions.Fetch)),
    map((action) => action.payload),
    mergeMap((params: FetchCommentsQuery) =>
      commentsServices.fetchComments(params).pipe(
        map((results) => actions.fetchSuccess(orderComments(results))),
        catchError((error) => of(actions.fetchFailure(error)))
      )
    )
  );

const postComment: Effect = (
  action$: EffectActionsObservable,
  state$: StateObservable<RootState>
) =>
  action$.pipe(
    filter(isActionType(CommentsActions.Post)),
    map((action) => ({
      form: action.payload,
      comments: store.getComments(state$.value),
    })),
    mergeMap(({ form, comments }) =>
      commentsServices.postComment(form, comments!).pipe(
        map(actions.postSuccess),
        catchError((error) => of(actions.postFailure(error)))
      )
    )
  );

const reset: Effect = (action$: EffectActionsObservable) =>
  action$.pipe(
    filter(isActionType(LOCATION_CHANGE)),
    map(() => actions.resetState())
  );

export const CommentsEffects = [fetchAfterPost, fetchComments, postComment, reset];
